import types from "../cart/types";


export const selectedAddress = (addressList) => (
    {
        type: types.SELECTED_ADDRESS,
        addressList,
    }
);